import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoElement } = this.refs;

    // iOS / mobile compatibility
    videoElement.muted = true;
    videoElement.defaultMuted = true;

    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');

    videoElement.autoplay = true;
    videoElement.playsInline = true;
    videoElement.loop = true;

    // Fonction sécurisée
    const playVideo = () => {
      const promise = videoElement.play();

      if (promise !== undefined) {
        promise.catch(() => {});
      }
    };

    // Lecture initiale
    playVideo();

    // Observer visibilité
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo();
          } else {
            videoElement.pause();
          }
        });
      },
      {
        threshold: 0.35,
      }
    );

    observer.observe(videoElement);

    // Fallback mobile
    document.addEventListener(
      'touchstart',
      () => {
        playVideo();
      },
      {
        passive: true,
      }
    );
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define(
    'video-background-component',
    VideoBackgroundComponent
  );
}